import { Injectable, inject } from '@angular/core';
import { OrderConstants } from '@easy-lib/constants/order.constants';

import { SymbolService } from '@easy-lib/modules/shared/services';
import { EasyValidityTypeCode, IOrder, IOrderValidationResultModel } from '../models/orderModels.model';
import { IBaseAlgoOrder } from '../../algo';
import { OrderStore } from '@easy-lib/state/orders';

@Injectable({
	providedIn: 'root'
})
export class OrderValidation {
	symbolService = inject(SymbolService);
	orderStore = inject(OrderStore);
	doBasicOrderValidations(order: IOrder): IOrderValidationResultModel {
		const { minDealableCount, minDealablePrice } = this.symbolService.symbolByIsin[order.symbolIsin];
		if (!order)
			return {
				successful: false,
				errorMessage: OrderConstants.ValidationMessages.OrderIsNotValid
			};
		if (!order.price)
			return {
				successful: false,
				errorMessage: OrderConstants.ValidationMessages.PriceIsEmpty
			};
		if (isNaN(order.price) || order.price <= 0)
			return {
				successful: false,
				errorMessage: OrderConstants.ValidationMessages.PriceIsNotValid
			};
		if (!order.quantity)
			return {
				successful: false,
				errorMessage: OrderConstants.ValidationMessages.QuantityIsEmpty
			};
		if (isNaN(order.quantity) || order.quantity <= 0)
			return {
				successful: false,
				errorMessage: OrderConstants.ValidationMessages.QuantityIsNotValid
			};
		if (
			order.validityDate &&
			[EasyValidityTypeCode.ValidToDate, EasyValidityTypeCode.Month, EasyValidityTypeCode.Week].includes(
				order.validityType
			)
		) {
			const validityDate = new Date(order.validityDate);
			const curDate = new Date();
			curDate.setHours(0, 0, 0, 0);
			if (validityDate < curDate)
				return {
					successful: false,
					errorMessage: OrderConstants.ValidationMessages.ValidityDateHasPastError
				};
			if (
				validityDate.getFullYear() === curDate.getFullYear() &&
				validityDate.getMonth() === curDate.getMonth() &&
				validityDate.getDate() === curDate.getDate()
			)
				return {
					successful: false,
					errorMessage: OrderConstants.ValidationMessages.ValidityDateEqualsTodayError
				};
		}
		if (order?.price % minDealablePrice !== 0) {
			return {
				successful: false,
				errorMessage: OrderConstants.ValidationMessages.MinDealablePrice + minDealablePrice + ' باشد.'
			};
		}
		if (order?.quantity % minDealableCount !== 0) {
			return {
				successful: false,
				errorMessage: OrderConstants.ValidationMessages.MinDealableVolume + minDealableCount + ' باشد.'
			};
		}
		return { successful: true, errorMessage: '' };
	}
	doBasicDraftValidations(order: IOrder): IOrderValidationResultModel {
		const result = this.doBasicOrderValidations(order);
		if (!result.successful) return result;
		const orderForEdit = { ...this.orderStore.getOrder(order.id) };
		if (
			+orderForEdit.quantity === +order.quantity &&
			+orderForEdit.price === +order.price &&
			orderForEdit.side === order.side &&
			orderForEdit.validityType === order.validityType &&
			orderForEdit.validityDate === order.validityDate
		) {
			return {
				successful: false,
				errorMessage: 'داده ای ویرایش نشده است'
			};
		}
		return { successful: true, errorMessage: '' };
	}
	doBasicAlgoValidations(order: IBaseAlgoOrder, buyBudget: boolean): IOrderValidationResultModel {
		if (!order)
			return {
				successful: false,
				errorMessage: OrderConstants.ValidationMessages.OrderIsNotValid
			};
		if (!order.price)
			return {
				successful: false,
				errorMessage: OrderConstants.ValidationMessages.PriceIsEmpty
			};
		if (isNaN(order.price) || order.price <= 0)
			return {
				successful: false,
				errorMessage: OrderConstants.ValidationMessages.PriceIsNotValid
			};
		if (!order.quantity)
			return {
				successful: false,
				errorMessage: buyBudget ? 'بودجه سفارش کافی نمیباشد' : OrderConstants.ValidationMessages.QuantityIsEmpty
			};
		if (isNaN(order.quantity) || order.quantity <= 0)
			return {
				successful: false,
				errorMessage: OrderConstants.ValidationMessages.QuantityIsNotValid
			};

		return { successful: true, errorMessage: '' };
	}
}
